module.exports = __webpack_public_path__ + "img/logo-xs-kpr.fd94d7b1.jpg";